module.exports = __webpack_public_path__ + "static/media/slider_1.128ca29d.webp";